import { getIsSubDomain } from './validation';

type PSLList = { [tld: string]: string[] };

export const getDomainNamePublicSuffix = (domainName: string, publicSuffixList: PSLList) => {
	const sortByLongestDomainPath = (a: string, b: string) => {
		const aLength = a.split('.').length;
		const bLength = b.split('.').length;
		return aLength > bLength ? -1 : bLength > aLength ? 1 : 0;
	};
	const topLevelDomain = domainName.split('.').pop();
	if (!topLevelDomain) return domainName;
	const publicSuffixesForTopLevelDomain: string[] | undefined = publicSuffixList[topLevelDomain];
	const publicSuffixesForTopLevelDomainSortedByLongest = publicSuffixesForTopLevelDomain?.sort(
		sortByLongestDomainPath,
	);
	const longestPublicSuffixMatch = publicSuffixesForTopLevelDomainSortedByLongest?.find((suffix) =>
		domainName.endsWith(suffix),
	);
	const publicSuffix = longestPublicSuffixMatch ?? topLevelDomain;
	return publicSuffix;
};

export const removePublicSuffixFromDomainName = (domainName: string, publicSuffix: string) => {
	const getEndingPublicSuffixRegexp = new RegExp(`.${publicSuffix}$`);
	const domainWithoutTop = domainName.replace(getEndingPublicSuffixRegexp, '');
	return domainWithoutTop;
};

export const domainWithWWW = (domainName: string) => {
	const parts = domainName.split('.');
	if (parts[0] === 'www') {
		return domainName;
	}
	return `www.${domainName}`;
};

export const domainWithoutWWW = (domainName: string) => {
	return domainName.startsWith('www.') ? domainName.replace('www.', '') : domainName;
};

// Valid custom domain format in our case means a subdomain, or a root domain with www prefix
export const formatAsCustomDomain = async (domainName: string): Promise<string> => {
	const isSubDomain = await getIsSubDomain(domainName);
	if (isSubDomain) return domainName;
	return domainWithWWW(domainName);
};

export const hostNameFromUrl = (stringUrl: string) => {
	const fullUrl = stringUrl.includes('http') ? stringUrl : `http://${stringUrl}`;
	const urlobj = new URL(fullUrl);
	return urlobj.hostname;
};
